import { makeStyles } from "@material-ui/core/styles";
import { Box, Container } from "@mui/material";
import clsx from 'clsx';
import { Loader } from "components";
import { format } from "date-fns";
import { useDocumementAg2r } from "features/arretTravail/contexts/DocumentAg2rProvider";
import { useEffect } from "react";
import iconDocument from '../../../../assets/document.svg';

const useStyles = makeStyles(() => ({
    txt: {
        color: '#4F7793',
        fontFeatureSettings: 'clig off, liga off',
        fontFamily: 'Segoe UI',
        fontSize: '16px',
        fontStyle: 'normal',
        lineHeight: '1rem',
        textTransform: 'uppercase'
    },
    txtUsername: {
        width: 300,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        textAlign: 'left'
    },
    txtCreatedAt: {
        width: 'fit-content',
        paddingLeft: '1.5rem',
        textAlign: 'center',
    },
    txtDocumentName: {
        width: 'fit-content',
        textAlign: 'left',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        paddingLeft: '1.5rem'
    },
    row: {
        borderBottom: '1px solid #E1E3E7',
        display: 'flex',
        alignItems: 'center',
        height: '40px',
    },
    notification: {
        color: '#4F7793',
        fontFeatureSettings: 'clig off, liga off',
        fontFamily: 'Segoe UI',
        fontSize: '14px',
        fontStyle: 'normal',
        lineHeight: '1rem',
        textTransform: 'uppercase',
        textAlign: 'center',
    },
    icon: {
        color: '#3399DB',
        cursor: 'pointer',
        width: '30px',
        height: '30px',
    },
}));

const HistoryDocumentLidl = (): JSX.Element => {
    const classes = useStyles();
    const { getListHistoryDocumentAg2r, loading, hisitoryDocumentAg2r } = useDocumementAg2r();

    useEffect(() => {
        getListHistoryDocumentAg2r()
    }, []);
    
    const hasHstoriyDocument = (): boolean => {
        if (hisitoryDocumentAg2r && hisitoryDocumentAg2r.length) return true;
        return false;
    };

    return (
        <Container>
            <Box>
                {hasHstoriyDocument() && !loading && 
                    <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2, mb: 5 }}>
                        <Box sx={{ flex: '1 1 auto' }} />
                            <Box className=" mt-0" style={{ width: '1000px' }}>
                                {hisitoryDocumentAg2r && hisitoryDocumentAg2r.map((historyUpload) => (
                                    <Box key={historyUpload.id} display={'flex'} flexDirection={'row'} className={classes.row} >
                                        <Box className="mr-3">
                                            <img src={iconDocument} alt={''} />
                                        </Box>
                                        <Box className={clsx(classes.txt, classes.txtUsername)}>{historyUpload.userName}</Box>    
                                        <Box className={clsx(classes.txt, classes.txtCreatedAt)}>{format(new Date( historyUpload.createdAt), 'dd/MM/yyyy à HH:mm:ss')}</Box>
                                        <Box className={clsx(classes.txt, classes.txtDocumentName)} flexGrow={'1'}>{historyUpload.documentName}</Box>                    
                                    </Box>
                                ))}
                            </Box>
                        <Box sx={{ flex: '1 1 auto' }} />
                    </Box>
                }

                {hisitoryDocumentAg2r && !hisitoryDocumentAg2r.length && !loading &&
                    <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', pt: 2, mb: 5 }}>
                        <Box className={classes.notification}> Aucun document</Box>
                    </Box>
                }

                {loading && 
                    <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', pt: 2, mb: 5 }}>
                        <Loader loading={loading} small></Loader>
                    </Box>
                }
            </Box>
        </Container>
    );
};

export default HistoryDocumentLidl;